import { Column } from 'material-table';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IDriverEarningTypes } from 'common/src/types';
import { CustomMaterialTable } from 'components/CustomMaterialTable';

export default function DriverEarning({ fleetAdminId, fleetAdminName }: { fleetAdminId?: string; fleetAdminName?: string }) {
  const { t } = useTranslation();

  const driverearningdata = useSelector(state => state.driverearningdata);

  const columns: Column<IDriverEarningTypes>[] = [
    { title: t('year'), field: 'year' },
    { title: t('months'), field: 'monthsName' },
    { title: t('driver_name'), field: 'driverName' },
    { title: t('booking_count'), field: 'total_rides' },
    { title: t('earning_amount'), field: 'driverShare' },
    { title: t('vehicle_reg_no'), field: 'driverVehicleNo' },
  ];

  return (
    <CustomMaterialTable
      columns={columns}
      isLoading={driverearningdata.loading}
      data={driverearningdata.driverearnings ?? []}
      title={(fleetAdminId ? `${t('driver_earning')} - ${fleetAdminName}` : t('driver_earning')) as any}
    />
  );
}